unit Unit2;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Modules, XData.Web.Connection,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.JSON,
  WEBLib.REST;

type
  TDM2 = class(TDataModule)
    XDataWebConnection1: TXDataWebConnection;
    xdsEinzeladresse: TXDataWebDataSet;
    sourceEinzeladresse: TDataSource;
    xdsLaender: TXDataWebDataSet;
    xdsLaenderLaenderkuerzel: TStringField;
    xdsLaenderLand: TStringField;
    xdsLaenderEULand: TIntegerField;
    sourceLaender: TDataSource;
    xdsProtokoll: TXDataWebDataSet;
    xdsProtokollID: TIntegerField;
    xdsProtokollDatum: TDateTimeField;
    xdsProtokollKundennummer: TStringField;
    xdsProtokollNotiz: TStringField;
    xdsProtokollPruefungErforderlich: TBooleanField;
    xdsProtokollPruefungErledigt: TDateTimeField;
    xdsProtokollPruefungErledigtDurch: TStringField;
    xdsProtokollBemerkung: TStringField;
    tableSYSDAT: TXDataWebDataSet;
    tableSYSDATDBKEY: TStringField;
    tableSYSDATNachname: TStringField;
    tableSYSDATVorname: TStringField;
    tableSYSDATNamenzeile2: TStringField;
    tableSYSDATNamenzeile3: TStringField;
    tableSYSDATStrasse: TStringField;
    tableSYSDATPostleitzahl: TStringField;
    tableSYSDATOrt: TStringField;
    tableSYSDATLaenderkuerzel: TStringField;
    tableSYSDATLand: TStringField;
    tableSYSDATTelefonnummer: TStringField;
    tableSYSDATTelefaxnummer: TStringField;
    tableSYSDATMobiltelefon: TStringField;
    tableSYSDATEmail: TStringField;
    tableSYSDATCadiaKundennummer: TStringField;
    tableSYSDATRundungIT: TBooleanField;
    tableSYSDATNachkommastellen: TIntegerField;
    sourceSysdat: TDataSource;
    WebHttpRequest2: THttpRequest;
    xdsKundenportalEinstellungen: TXDataWebDataSet;
    xdsKundenportalEinstellungenID: TIntegerField;
    xdsKundenportalEinstellungenLinkImpressum: TStringField;
    xdsKundenportalEinstellungenLinkDatenschutz: TStringField;
    xdsKundenportalEinstellungenLinkAGB: TStringField;
    xdsKundenportalEinstellungenKdpUserName: TStringField;
    xdsKundenportalEinstellungenKdpPassword: TStringField;
    xdsKundenportalEinstellungenKdpOrdner: TStringField;
    xdsKundenportalEinstellungenKdpPfad: TStringField;
    xdsKundenportalEinstellungenKdpFarben: TStringField;
    xdsKundenportalEinstellungenEmailKonto: TStringField;
    xdsKundenportalEinstellungenEmailtextPasswortVergessen: TStringField;
    procedure XDataWebConnection1Request(Args: TXDataWebConnectionRequest);
    procedure XDataWebConnection1Connect(Sender: TObject);
    procedure tableSYSDATAfterOpen(DataSet: TDataSet);
    procedure WebHttpRequest2Response(Sender: TObject; AResponse: string);
    procedure xdsKundenportalEinstellungenAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  DM2: TDM2;

implementation
  uses unit1;
{%CLASSGROUP 'Vcl.Controls.TControl'}

{$R *.dfm}

procedure TDM2.tableSYSDATAfterOpen(DataSet: TDataSet);
begin
  WebHttpRequest2.URL:='https://cadia-software.net/cadiaautoserver/xdata/InformationService/cwlizenzonly?Kundennummer='+tableSYSDATCadiaKundennummer.AsString+'&AppKey='+CadiaAppKeyServerLizenz;
  WebHttpRequest2.Execute;

end;

procedure TDM2.WebHttpRequest2Response(Sender: TObject; AResponse: string);
var
  JS:TJSON;
  JV:TJSONValue;
begin
  JS:=TJSON.Create;
  JV:=JS.Parse(AResponse);
  if assigned(JV) and (JV is TJSONObject) then
  begin
    if TJSONObject(JV).GetJSONValue('value')='OK' then LizenzOK:=true;
    form1.labelonlinestatus.Caption:='Lizenz vorhanden: '+TJSONObject(JV).GetJSONValue('value');
  end;
  dm2.xdsKundenportalEinstellungen.Load;
end;

procedure TDM2.XDataWebConnection1Connect(Sender: TObject);
begin
  tablesysdat.Load;
end;

procedure TDM2.XDataWebConnection1Request(Args: TXDataWebConnectionRequest);
begin
  args.Request.Headers.SetValue('Authorization','Bearer ' + vToken);
end;

procedure TDM2.xdsKundenportalEinstellungenAfterOpen(DataSet: TDataSet);
begin
  MyLinkImpressum:=xdsKundenportalEinstellungenLinkImpressum.AsString;
  MyLinkDatenschutz:=xdsKundenportalEinstellungenLinkDatenschutz.AsString;
  MyLinkAGB:=xdsKundenportalEinstellungenLinkAGB.AsString;
  MyEmailKonto:=xdsKundenportalEinstellungenEmailKonto.AsString;
  form1.setcontrols;
end;

procedure TDM2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  XDataWebConnection1 := TXDataWebConnection.Create(Self);
  xdsEinzeladresse := TXDataWebDataSet.Create(Self);
  sourceEinzeladresse := TDataSource.Create(Self);
  xdsLaender := TXDataWebDataSet.Create(Self);
  xdsLaenderLaenderkuerzel := TStringField.Create(Self);
  xdsLaenderLand := TStringField.Create(Self);
  xdsLaenderEULand := TIntegerField.Create(Self);
  sourceLaender := TDataSource.Create(Self);
  xdsProtokoll := TXDataWebDataSet.Create(Self);
  xdsProtokollID := TIntegerField.Create(Self);
  xdsProtokollDatum := TDateTimeField.Create(Self);
  xdsProtokollKundennummer := TStringField.Create(Self);
  xdsProtokollNotiz := TStringField.Create(Self);
  xdsProtokollPruefungErforderlich := TBooleanField.Create(Self);
  xdsProtokollPruefungErledigt := TDateTimeField.Create(Self);
  xdsProtokollPruefungErledigtDurch := TStringField.Create(Self);
  xdsProtokollBemerkung := TStringField.Create(Self);
  tableSYSDAT := TXDataWebDataSet.Create(Self);
  tableSYSDATDBKEY := TStringField.Create(Self);
  tableSYSDATNachname := TStringField.Create(Self);
  tableSYSDATVorname := TStringField.Create(Self);
  tableSYSDATNamenzeile2 := TStringField.Create(Self);
  tableSYSDATNamenzeile3 := TStringField.Create(Self);
  tableSYSDATStrasse := TStringField.Create(Self);
  tableSYSDATPostleitzahl := TStringField.Create(Self);
  tableSYSDATOrt := TStringField.Create(Self);
  tableSYSDATLaenderkuerzel := TStringField.Create(Self);
  tableSYSDATLand := TStringField.Create(Self);
  tableSYSDATTelefonnummer := TStringField.Create(Self);
  tableSYSDATTelefaxnummer := TStringField.Create(Self);
  tableSYSDATMobiltelefon := TStringField.Create(Self);
  tableSYSDATEmail := TStringField.Create(Self);
  tableSYSDATCadiaKundennummer := TStringField.Create(Self);
  tableSYSDATRundungIT := TBooleanField.Create(Self);
  tableSYSDATNachkommastellen := TIntegerField.Create(Self);
  sourceSysdat := TDataSource.Create(Self);
  WebHttpRequest2 := THttpRequest.Create(Self);
  xdsKundenportalEinstellungen := TXDataWebDataSet.Create(Self);
  xdsKundenportalEinstellungenID := TIntegerField.Create(Self);
  xdsKundenportalEinstellungenLinkImpressum := TStringField.Create(Self);
  xdsKundenportalEinstellungenLinkDatenschutz := TStringField.Create(Self);
  xdsKundenportalEinstellungenLinkAGB := TStringField.Create(Self);
  xdsKundenportalEinstellungenKdpUserName := TStringField.Create(Self);
  xdsKundenportalEinstellungenKdpPassword := TStringField.Create(Self);
  xdsKundenportalEinstellungenKdpOrdner := TStringField.Create(Self);
  xdsKundenportalEinstellungenKdpPfad := TStringField.Create(Self);
  xdsKundenportalEinstellungenKdpFarben := TStringField.Create(Self);
  xdsKundenportalEinstellungenEmailKonto := TStringField.Create(Self);
  xdsKundenportalEinstellungenEmailtextPasswortVergessen := TStringField.Create(Self);

  XDataWebConnection1.BeforeLoadDFMValues;
  xdsEinzeladresse.BeforeLoadDFMValues;
  sourceEinzeladresse.BeforeLoadDFMValues;
  xdsLaender.BeforeLoadDFMValues;
  xdsLaenderLaenderkuerzel.BeforeLoadDFMValues;
  xdsLaenderLand.BeforeLoadDFMValues;
  xdsLaenderEULand.BeforeLoadDFMValues;
  sourceLaender.BeforeLoadDFMValues;
  xdsProtokoll.BeforeLoadDFMValues;
  xdsProtokollID.BeforeLoadDFMValues;
  xdsProtokollDatum.BeforeLoadDFMValues;
  xdsProtokollKundennummer.BeforeLoadDFMValues;
  xdsProtokollNotiz.BeforeLoadDFMValues;
  xdsProtokollPruefungErforderlich.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigt.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigtDurch.BeforeLoadDFMValues;
  xdsProtokollBemerkung.BeforeLoadDFMValues;
  tableSYSDAT.BeforeLoadDFMValues;
  tableSYSDATDBKEY.BeforeLoadDFMValues;
  tableSYSDATNachname.BeforeLoadDFMValues;
  tableSYSDATVorname.BeforeLoadDFMValues;
  tableSYSDATNamenzeile2.BeforeLoadDFMValues;
  tableSYSDATNamenzeile3.BeforeLoadDFMValues;
  tableSYSDATStrasse.BeforeLoadDFMValues;
  tableSYSDATPostleitzahl.BeforeLoadDFMValues;
  tableSYSDATOrt.BeforeLoadDFMValues;
  tableSYSDATLaenderkuerzel.BeforeLoadDFMValues;
  tableSYSDATLand.BeforeLoadDFMValues;
  tableSYSDATTelefonnummer.BeforeLoadDFMValues;
  tableSYSDATTelefaxnummer.BeforeLoadDFMValues;
  tableSYSDATMobiltelefon.BeforeLoadDFMValues;
  tableSYSDATEmail.BeforeLoadDFMValues;
  tableSYSDATCadiaKundennummer.BeforeLoadDFMValues;
  tableSYSDATRundungIT.BeforeLoadDFMValues;
  tableSYSDATNachkommastellen.BeforeLoadDFMValues;
  sourceSysdat.BeforeLoadDFMValues;
  WebHttpRequest2.BeforeLoadDFMValues;
  xdsKundenportalEinstellungen.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenID.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenLinkImpressum.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenLinkDatenschutz.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenLinkAGB.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenKdpUserName.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenKdpPassword.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenKdpOrdner.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenKdpPfad.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenKdpFarben.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenEmailKonto.BeforeLoadDFMValues;
  xdsKundenportalEinstellungenEmailtextPasswortVergessen.BeforeLoadDFMValues;
  try
    Name := 'DM2';
    Height := 482;
    Width := 375;
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    XDataWebConnection1.URL := 'https://langwald-edv.net:443/mandant01/cadiaserver/xdata';
    XDataWebConnection1.DesignData.Persist := True;
    SetEvent(XDataWebConnection1, Self, 'OnConnect', 'XDataWebConnection1Connect');
    SetEvent(XDataWebConnection1, Self, 'OnRequest', 'XDataWebConnection1Request');
    XDataWebConnection1.Left := 88;
    XDataWebConnection1.Top := 16;
    xdsEinzeladresse.SetParentComponent(Self);
    xdsEinzeladresse.Name := 'xdsEinzeladresse';
    xdsEinzeladresse.EntitySetName := 'Adressen';
    xdsEinzeladresse.Connection := XDataWebConnection1;
    xdsEinzeladresse.Left := 72;
    xdsEinzeladresse.Top := 200;
    sourceEinzeladresse.SetParentComponent(Self);
    sourceEinzeladresse.Name := 'sourceEinzeladresse';
    sourceEinzeladresse.DataSet := xdsEinzeladresse;
    sourceEinzeladresse.Left := 184;
    sourceEinzeladresse.Top := 200;
    xdsLaender.SetParentComponent(Self);
    xdsLaender.Name := 'xdsLaender';
    xdsLaender.EntitySetName := 'Laender';
    xdsLaender.Connection := XDataWebConnection1;
    xdsLaender.Left := 64;
    xdsLaender.Top := 264;
    xdsLaenderLaenderkuerzel.SetParentComponent(xdsLaender);
    xdsLaenderLaenderkuerzel.Name := 'xdsLaenderLaenderkuerzel';
    xdsLaenderLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsLaenderLaenderkuerzel.Required := True;
    xdsLaenderLaenderkuerzel.Size := 5;
    xdsLaenderLand.SetParentComponent(xdsLaender);
    xdsLaenderLand.Name := 'xdsLaenderLand';
    xdsLaenderLand.FieldName := 'Land';
    xdsLaenderEULand.SetParentComponent(xdsLaender);
    xdsLaenderEULand.Name := 'xdsLaenderEULand';
    xdsLaenderEULand.FieldName := 'EULand';
    sourceLaender.SetParentComponent(Self);
    sourceLaender.Name := 'sourceLaender';
    sourceLaender.DataSet := xdsEinzeladresse;
    sourceLaender.Left := 184;
    sourceLaender.Top := 264;
    xdsProtokoll.SetParentComponent(Self);
    xdsProtokoll.Name := 'xdsProtokoll';
    xdsProtokoll.EntitySetName := 'KundenportalProtokoll';
    xdsProtokoll.Connection := XDataWebConnection1;
    xdsProtokoll.QueryTop := 1;
    xdsProtokoll.Left := 304;
    xdsProtokoll.Top := 200;
    xdsProtokollID.SetParentComponent(xdsProtokoll);
    xdsProtokollID.Name := 'xdsProtokollID';
    xdsProtokollID.FieldName := 'ID';
    xdsProtokollDatum.SetParentComponent(xdsProtokoll);
    xdsProtokollDatum.Name := 'xdsProtokollDatum';
    xdsProtokollDatum.FieldName := 'Datum';
    xdsProtokollKundennummer.SetParentComponent(xdsProtokoll);
    xdsProtokollKundennummer.Name := 'xdsProtokollKundennummer';
    xdsProtokollKundennummer.FieldName := 'Kundennummer';
    xdsProtokollKundennummer.Size := 13;
    xdsProtokollNotiz.SetParentComponent(xdsProtokoll);
    xdsProtokollNotiz.Name := 'xdsProtokollNotiz';
    xdsProtokollNotiz.FieldName := 'Notiz';
    xdsProtokollNotiz.Size := 250;
    xdsProtokollPruefungErforderlich.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErforderlich.Name := 'xdsProtokollPruefungErforderlich';
    xdsProtokollPruefungErforderlich.FieldName := 'PruefungErforderlich';
    xdsProtokollPruefungErledigt.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigt.Name := 'xdsProtokollPruefungErledigt';
    xdsProtokollPruefungErledigt.FieldName := 'PruefungErledigt';
    xdsProtokollPruefungErledigtDurch.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigtDurch.Name := 'xdsProtokollPruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.FieldName := 'PruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.Size := 50;
    xdsProtokollBemerkung.SetParentComponent(xdsProtokoll);
    xdsProtokollBemerkung.Name := 'xdsProtokollBemerkung';
    xdsProtokollBemerkung.FieldName := 'Bemerkung';
    xdsProtokollBemerkung.Size := 255;
    tableSYSDAT.SetParentComponent(Self);
    tableSYSDAT.Name := 'tableSYSDAT';
    tableSYSDAT.AfterOpen := tableSYSDATAfterOpen;
    tableSYSDAT.EntitySetName := 'sysdat';
    tableSYSDAT.Connection := XDataWebConnection1;
    tableSYSDAT.Left := 184;
    tableSYSDAT.Top := 104;
    tableSYSDATDBKEY.SetParentComponent(tableSYSDAT);
    tableSYSDATDBKEY.Name := 'tableSYSDATDBKEY';
    tableSYSDATDBKEY.FieldName := 'DBKEY';
    tableSYSDATDBKEY.Size := 38;
    tableSYSDATNachname.SetParentComponent(tableSYSDAT);
    tableSYSDATNachname.Name := 'tableSYSDATNachname';
    tableSYSDATNachname.FieldName := 'Nachname';
    tableSYSDATNachname.Size := 40;
    tableSYSDATVorname.SetParentComponent(tableSYSDAT);
    tableSYSDATVorname.Name := 'tableSYSDATVorname';
    tableSYSDATVorname.FieldName := 'Vorname';
    tableSYSDATVorname.Size := 40;
    tableSYSDATNamenzeile2.SetParentComponent(tableSYSDAT);
    tableSYSDATNamenzeile2.Name := 'tableSYSDATNamenzeile2';
    tableSYSDATNamenzeile2.FieldName := 'Namenzeile2';
    tableSYSDATNamenzeile2.Size := 40;
    tableSYSDATNamenzeile3.SetParentComponent(tableSYSDAT);
    tableSYSDATNamenzeile3.Name := 'tableSYSDATNamenzeile3';
    tableSYSDATNamenzeile3.FieldName := 'Namenzeile3';
    tableSYSDATNamenzeile3.Size := 40;
    tableSYSDATStrasse.SetParentComponent(tableSYSDAT);
    tableSYSDATStrasse.Name := 'tableSYSDATStrasse';
    tableSYSDATStrasse.FieldName := 'Strasse';
    tableSYSDATStrasse.Size := 40;
    tableSYSDATPostleitzahl.SetParentComponent(tableSYSDAT);
    tableSYSDATPostleitzahl.Name := 'tableSYSDATPostleitzahl';
    tableSYSDATPostleitzahl.FieldName := 'Postleitzahl';
    tableSYSDATPostleitzahl.Size := 6;
    tableSYSDATOrt.SetParentComponent(tableSYSDAT);
    tableSYSDATOrt.Name := 'tableSYSDATOrt';
    tableSYSDATOrt.FieldName := 'Ort';
    tableSYSDATOrt.Size := 40;
    tableSYSDATLaenderkuerzel.SetParentComponent(tableSYSDAT);
    tableSYSDATLaenderkuerzel.Name := 'tableSYSDATLaenderkuerzel';
    tableSYSDATLaenderkuerzel.FieldName := 'Laenderkuerzel';
    tableSYSDATLaenderkuerzel.Size := 5;
    tableSYSDATLand.SetParentComponent(tableSYSDAT);
    tableSYSDATLand.Name := 'tableSYSDATLand';
    tableSYSDATLand.FieldName := 'Land';
    tableSYSDATLand.Size := 40;
    tableSYSDATTelefonnummer.SetParentComponent(tableSYSDAT);
    tableSYSDATTelefonnummer.Name := 'tableSYSDATTelefonnummer';
    tableSYSDATTelefonnummer.FieldName := 'Telefonnummer';
    tableSYSDATTelefonnummer.Size := 25;
    tableSYSDATTelefaxnummer.SetParentComponent(tableSYSDAT);
    tableSYSDATTelefaxnummer.Name := 'tableSYSDATTelefaxnummer';
    tableSYSDATTelefaxnummer.FieldName := 'Telefaxnummer';
    tableSYSDATTelefaxnummer.Size := 25;
    tableSYSDATMobiltelefon.SetParentComponent(tableSYSDAT);
    tableSYSDATMobiltelefon.Name := 'tableSYSDATMobiltelefon';
    tableSYSDATMobiltelefon.FieldName := 'Mobiltelefon';
    tableSYSDATMobiltelefon.Size := 25;
    tableSYSDATEmail.SetParentComponent(tableSYSDAT);
    tableSYSDATEmail.Name := 'tableSYSDATEmail';
    tableSYSDATEmail.FieldName := 'Email';
    tableSYSDATEmail.Size := 70;
    tableSYSDATCadiaKundennummer.SetParentComponent(tableSYSDAT);
    tableSYSDATCadiaKundennummer.Name := 'tableSYSDATCadiaKundennummer';
    tableSYSDATCadiaKundennummer.FieldName := 'CadiaKundennummer';
    tableSYSDATCadiaKundennummer.Size := 13;
    tableSYSDATRundungIT.SetParentComponent(tableSYSDAT);
    tableSYSDATRundungIT.Name := 'tableSYSDATRundungIT';
    tableSYSDATRundungIT.FieldName := 'RundungIT';
    tableSYSDATNachkommastellen.SetParentComponent(tableSYSDAT);
    tableSYSDATNachkommastellen.Name := 'tableSYSDATNachkommastellen';
    tableSYSDATNachkommastellen.FieldName := 'Nachkommastellen';
    sourceSysdat.SetParentComponent(Self);
    sourceSysdat.Name := 'sourceSysdat';
    sourceSysdat.DataSet := tableSYSDAT;
    sourceSysdat.Left := 80;
    sourceSysdat.Top := 104;
    WebHttpRequest2.SetParentComponent(Self);
    WebHttpRequest2.Name := 'WebHttpRequest2';
    WebHttpRequest2.Headers.BeginUpdate;
    try
      WebHttpRequest2.Headers.Clear;
      WebHttpRequest2.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest2.Headers.EndUpdate;
    end;
    WebHttpRequest2.URL := 'https://langwald-edv.net/cadiaserver/xdata/$model';
    SetEvent(WebHttpRequest2, Self, 'OnResponse', 'WebHttpRequest2Response');
    WebHttpRequest2.Left := 232;
    WebHttpRequest2.Top := 16;
    xdsKundenportalEinstellungen.SetParentComponent(Self);
    xdsKundenportalEinstellungen.Name := 'xdsKundenportalEinstellungen';
    xdsKundenportalEinstellungen.AfterOpen := xdsKundenportalEinstellungenAfterOpen;
    xdsKundenportalEinstellungen.EntitySetName := 'KundenportalEinstellungen';
    xdsKundenportalEinstellungen.Connection := XDataWebConnection1;
    xdsKundenportalEinstellungen.Left := 64;
    xdsKundenportalEinstellungen.Top := 360;
    xdsKundenportalEinstellungenID.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenID.Name := 'xdsKundenportalEinstellungenID';
    xdsKundenportalEinstellungenID.FieldName := 'ID';
    xdsKundenportalEinstellungenLinkImpressum.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenLinkImpressum.Name := 'xdsKundenportalEinstellungenLinkImpressum';
    xdsKundenportalEinstellungenLinkImpressum.FieldName := 'LinkImpressum';
    xdsKundenportalEinstellungenLinkImpressum.Size := 100;
    xdsKundenportalEinstellungenLinkDatenschutz.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenLinkDatenschutz.Name := 'xdsKundenportalEinstellungenLinkDatenschutz';
    xdsKundenportalEinstellungenLinkDatenschutz.FieldName := 'LinkDatenschutz';
    xdsKundenportalEinstellungenLinkDatenschutz.Size := 100;
    xdsKundenportalEinstellungenLinkAGB.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenLinkAGB.Name := 'xdsKundenportalEinstellungenLinkAGB';
    xdsKundenportalEinstellungenLinkAGB.FieldName := 'LinkAGB';
    xdsKundenportalEinstellungenLinkAGB.Size := 100;
    xdsKundenportalEinstellungenKdpUserName.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenKdpUserName.Name := 'xdsKundenportalEinstellungenKdpUserName';
    xdsKundenportalEinstellungenKdpUserName.FieldName := 'KdpUserName';
    xdsKundenportalEinstellungenKdpUserName.Size := 50;
    xdsKundenportalEinstellungenKdpPassword.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenKdpPassword.Name := 'xdsKundenportalEinstellungenKdpPassword';
    xdsKundenportalEinstellungenKdpPassword.FieldName := 'KdpPassword';
    xdsKundenportalEinstellungenKdpPassword.Size := 50;
    xdsKundenportalEinstellungenKdpOrdner.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenKdpOrdner.Name := 'xdsKundenportalEinstellungenKdpOrdner';
    xdsKundenportalEinstellungenKdpOrdner.FieldName := 'KdpOrdner';
    xdsKundenportalEinstellungenKdpOrdner.Size := 50;
    xdsKundenportalEinstellungenKdpPfad.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenKdpPfad.Name := 'xdsKundenportalEinstellungenKdpPfad';
    xdsKundenportalEinstellungenKdpPfad.FieldName := 'KdpPfad';
    xdsKundenportalEinstellungenKdpPfad.Size := 50;
    xdsKundenportalEinstellungenKdpFarben.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenKdpFarben.Name := 'xdsKundenportalEinstellungenKdpFarben';
    xdsKundenportalEinstellungenKdpFarben.FieldName := 'KdpFarben';
    xdsKundenportalEinstellungenKdpFarben.Size := 255;
    xdsKundenportalEinstellungenEmailKonto.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenEmailKonto.Name := 'xdsKundenportalEinstellungenEmailKonto';
    xdsKundenportalEinstellungenEmailKonto.FieldName := 'EmailKonto';
    xdsKundenportalEinstellungenEmailKonto.Size := 50;
    xdsKundenportalEinstellungenEmailtextPasswortVergessen.SetParentComponent(xdsKundenportalEinstellungen);
    xdsKundenportalEinstellungenEmailtextPasswortVergessen.Name := 'xdsKundenportalEinstellungenEmailtextPasswortVergessen';
    xdsKundenportalEinstellungenEmailtextPasswortVergessen.FieldName := 'EmailtextPasswortVergessen';
    xdsKundenportalEinstellungenEmailtextPasswortVergessen.Size := 255;
  finally
    XDataWebConnection1.AfterLoadDFMValues;
    xdsEinzeladresse.AfterLoadDFMValues;
    sourceEinzeladresse.AfterLoadDFMValues;
    xdsLaender.AfterLoadDFMValues;
    xdsLaenderLaenderkuerzel.AfterLoadDFMValues;
    xdsLaenderLand.AfterLoadDFMValues;
    xdsLaenderEULand.AfterLoadDFMValues;
    sourceLaender.AfterLoadDFMValues;
    xdsProtokoll.AfterLoadDFMValues;
    xdsProtokollID.AfterLoadDFMValues;
    xdsProtokollDatum.AfterLoadDFMValues;
    xdsProtokollKundennummer.AfterLoadDFMValues;
    xdsProtokollNotiz.AfterLoadDFMValues;
    xdsProtokollPruefungErforderlich.AfterLoadDFMValues;
    xdsProtokollPruefungErledigt.AfterLoadDFMValues;
    xdsProtokollPruefungErledigtDurch.AfterLoadDFMValues;
    xdsProtokollBemerkung.AfterLoadDFMValues;
    tableSYSDAT.AfterLoadDFMValues;
    tableSYSDATDBKEY.AfterLoadDFMValues;
    tableSYSDATNachname.AfterLoadDFMValues;
    tableSYSDATVorname.AfterLoadDFMValues;
    tableSYSDATNamenzeile2.AfterLoadDFMValues;
    tableSYSDATNamenzeile3.AfterLoadDFMValues;
    tableSYSDATStrasse.AfterLoadDFMValues;
    tableSYSDATPostleitzahl.AfterLoadDFMValues;
    tableSYSDATOrt.AfterLoadDFMValues;
    tableSYSDATLaenderkuerzel.AfterLoadDFMValues;
    tableSYSDATLand.AfterLoadDFMValues;
    tableSYSDATTelefonnummer.AfterLoadDFMValues;
    tableSYSDATTelefaxnummer.AfterLoadDFMValues;
    tableSYSDATMobiltelefon.AfterLoadDFMValues;
    tableSYSDATEmail.AfterLoadDFMValues;
    tableSYSDATCadiaKundennummer.AfterLoadDFMValues;
    tableSYSDATRundungIT.AfterLoadDFMValues;
    tableSYSDATNachkommastellen.AfterLoadDFMValues;
    sourceSysdat.AfterLoadDFMValues;
    WebHttpRequest2.AfterLoadDFMValues;
    xdsKundenportalEinstellungen.AfterLoadDFMValues;
    xdsKundenportalEinstellungenID.AfterLoadDFMValues;
    xdsKundenportalEinstellungenLinkImpressum.AfterLoadDFMValues;
    xdsKundenportalEinstellungenLinkDatenschutz.AfterLoadDFMValues;
    xdsKundenportalEinstellungenLinkAGB.AfterLoadDFMValues;
    xdsKundenportalEinstellungenKdpUserName.AfterLoadDFMValues;
    xdsKundenportalEinstellungenKdpPassword.AfterLoadDFMValues;
    xdsKundenportalEinstellungenKdpOrdner.AfterLoadDFMValues;
    xdsKundenportalEinstellungenKdpPfad.AfterLoadDFMValues;
    xdsKundenportalEinstellungenKdpFarben.AfterLoadDFMValues;
    xdsKundenportalEinstellungenEmailKonto.AfterLoadDFMValues;
    xdsKundenportalEinstellungenEmailtextPasswortVergessen.AfterLoadDFMValues;
  end;
end;

end.
